'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

class FAQs {
  get(lang) {
    const params = { lang };
    return index.adapter.faqs.get(params).then((values) => values.filter((entry) => {
      return entry.question && entry.answer;
    }).sort((a, b) => a.position < b.position ? -1 : 1));
  }
  getByCatId(catId) {
    const params = { catId };
    return index.adapter.faqs.getByCatId(params);
  }
}
const faqs = new FAQs();

exports.faqs = faqs;
